import { motion } from "framer-motion";
import logo from "@/assets/azzaro-logo.png";

export const Header = () => {
  return (
    <motion.header
      data-testid="site-header"
      initial={{ opacity: 0, y: -14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="relative z-40 w-full bg-white"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-center px-6 pt-10 pb-6">
        <img
          src={logo}
          alt="Azzaro Resorts & Spa"
          data-testid="azzaro-logo"
          className="h-16 w-auto select-none sm:h-20"
          draggable="false"
        />
      </div>
      <div className="mx-auto max-w-6xl px-6">
        <div className="hairline" />
      </div>
    </motion.header>
  );
};

export default Header;
